import React from "react";
import { useNavigate } from "react-router";
import { useState, useEffect, useContext } from "react";
import TablePlaceholder from "../Utils/TablePlaceholder";
import dateFormatter from "../Utils/dateFormatter";
import { RiArrowRightUpLine, RiArrowLeftDownLine } from "react-icons/ri";
import MenuButtons from "../components/billings/MenuButtons";
import {
  getAllBilling,
  saveSelectedBilling,
  deleteBilling,
  editBilling,
} from "../Utils/localStore";
import Topnav from "../components/others/Topnav";
import ToastContext from "../context/toasterContex";
import MoreActionButton from "../components/patient/utils/MoreActionButton";

const AllInvoiceReport = ({ recent }) => {
  const navigate = useNavigate();
  const { toast } = useContext(ToastContext);
  const [filter, setFilter] = useState("all");
  const [showDelete, setShowDelete] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [report, setReport] = useState(null);
  const [statusModal, setStatusModal] = useState(false);

  const handleChildAction = async (mode, details) => {
    if (mode === "view") {
      try {
        await saveSelectedBilling(details).then((resp) => {
          details?.invoiceType === 'inventory' ?
          navigate("/billings/inventory_invoice?mode=summary")
          : 
          navigate("/billings/service_invoice?mode=summary")
        });
      } catch (error) {
        console.log({ error });
      }
    } else if (mode === "edit") {
      try {
        await saveSelectedBilling(details).then((resp) => {
          details?.invoiceType === 'inventory' ?
          navigate("/billings/inventory_invoice?mode=edit")
          : 
          navigate("/billings/service_invoice?mode=edit")
        });
      } catch (error) {
        console.log({ error });
      }
    } else if (mode === "delete") {
      try {
        setShowDelete(true);
        setSelectedRecord(details);
      } catch (error) {
        console.log({ error });
      }
    }
  };
  const openStatusChange = async (item) => {
    await setSelectedRecord(item);
    await setStatusModal(true);
  };
  const updateStatusChange = async () => {
    let newRec = selectedRecord;
    const newstatus =
      newRec.status?.toLowerCase() === "paid" ? "Unpaid" : "Paid";
    newRec.status = newstatus;
    await editBilling(newRec)
      .then(() => {
        toast.success("Status updated successfully", {
          position: toast.POSITION.TOP_CENTER,
        });
        setStatusModal(false);
        getLocalData();
      })
      .catch((error) => {
        toast.error("Failed to update status", {
          position: toast.POSITION.TOP_CENTER,
        });
        setStatusModal(false);
        getLocalData();
      });
  };
  const getLocalData = async () => {
    let response;
    try {
      await getAllBilling().then((resp) => (response = resp));
      return setReport(response);
    } catch (error) {
      toast.error(error, { position: toast.POSITION.TOP_CENTER });
      throw new Error(error);
    }
  };

  let filteredItems = report?.filter((item) => {
    if (filter === "all") {
      return item;
    } else if (filter === "Dispensed") {
      return item.status?.toLowerCase() === "paid";
    } else if (filter === "Expired") {
      return item.status?.toLowerCase() === "unpaid";
    }
  });

  if (recent) filteredItems?.slice(0, 7);

  const handleDeleteAction = async () => {
    try {
      const response = await deleteBilling(selectedRecord.localID).then(
        (resp) => {
          getLocalData();
          toast.success("Record deleted successfully", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      );
    } catch (error) {
      toast.error("Something went wrong, please try again later", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
    setShowDelete(false);
  };

  useEffect(() => {
    getLocalData();
  }, [report]);

  return (
    <>
      {!recent && (
        <>
          <Topnav />
          <div className="p-4 flex justify-end">
            <MenuButtons mode={"sub"} />
          </div>
        </>
      )}
      <div className="report">
        {showDelete && (
          <dialog>
            <div className="w-[300px] bg-white rounded-md p-8 border">
              <p className="text-center mb-6">
                Are you sure you want to delete this record?
              </p>
              <div className="flex justify-between">
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    handleDeleteAction();
                  }}
                  className="rounded-md text-white bg-primary p-2"
                >
                  Confirm
                </button>
                <button
                  autoFocus
                  className="p-2"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowDelete(false);
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </dialog>
        )}
        {statusModal && (
          <dialog>
            <div className="w-[300px] bg-white rounded-md p-8 border">
              <p className="text-center mb-6">
                Are you sure you want to
                {selectedRecord.status?.toLowerCase() === "unpaid"
                  ? " Mark this invoice as Paid?"
                  : " Mark this invoice as Unpaid?"}
              </p>
              <div className="flex justify-between">
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    updateStatusChange();
                  }}
                  className="rounded-md text-white bg-primary p-2"
                >
                  Confirm
                </button>
                <button
                  autoFocus
                  className="p-2"
                  onClick={(e) => {
                    e.preventDefault();
                    setStatusModal(false);
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </dialog>
        )}
        {!recent && (
          <div className="report_header">
            <div className="button">
              <button
                className={filter === "all" ? "active" : ""}
                onClick={() => setFilter("all")}
              >
                All Invoices
              </button>
              <button
                className={filter === "Dispensed" ? "active" : ""}
                onClick={() => setFilter("Dispensed")}
              >
                Paid Income
              </button>
              <button
                className={filter === "Expired" ? "active" : ""}
                onClick={() => setFilter("Expired")}
              >
                Unpaid Invoices
              </button>
            </div>
            <button>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M3 7H21"
                  stroke="#009FE3"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
                <path
                  d="M6 12H18"
                  stroke="#009FE3"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
                <path
                  d="M10 17H14"
                  stroke="#009FE3"
                  strokeWidth="1.5"
                  stroke-inecap="round"
                />
              </svg>
              Filter
            </button>
          </div>
        )}
        <div className="report_table">
          {filteredItems && filteredItems.length ? (
            <table>
              <thead>
                <tr>
                  <th className="tag_1">
                    {/* <input type="checkbox" name="Prescription ID" id="pre_id" />{" "} */}
                    <span>Client ID</span>
                  </th>
                  <th>Client Name</th>
                  <th>Department</th>
                  <th>Date </th>
                  <th className="status_head">
                    <span>Status</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredItems.slice(0, recent).map((item, index) => (
                  <tr className={`${item.status}`} key={item.localID}>
                    <td className="data">
                      {" "}
                      <div className="flex">
                        <div className="tag">
                          {/* <input
                          type="checkbox"
                          name="Prescription ID"
                          id="pre_id"
                        /> */}
                          {index + 1}
                        </div>
                        <div
                          className={`activity_icon ${item.status?.toLowerCase()}`}
                        >
                          {item.status?.toLowerCase() === "pending" ||
                          item.status?.toLowerCase() === "unpaid" ? (
                            <div
                              className={`h-14 w-14 rounded-full bg-red-100 ${item.type} flex ml-2  justify-center items-center`}
                            >
                              <RiArrowLeftDownLine
                                color="red"
                                size={25}
                                className="items-center"
                              />
                            </div>
                          ) : (
                            <div
                              className={`h-14 w-14 rounded-full bg-green-100 ${item.type} flex  ml-2 justify-center items-center`}
                            >
                              <RiArrowRightUpLine
                                color="green"
                                size={25}
                                className="items-center"
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </td>
                    <td className="capitalize">
                      {item?.user?.patientName || item.name || "-"}
                    </td>
                    <td className="capitalize">{item.client_type || "-"}</td>
                    <td className="capitalize">
                      {dateFormatter(item.date) || "-"}
                    </td>
                    <td className="status">
                      <div
                        className={` flex ml-2  justify-center items-center`}
                      >
                        <span
                          className={`p-1 px-3 text-sm rounded-2xl border ${
                            item.status?.toLowerCase() === "paid"
                              ? "border-green-700 bg-green-100"
                              : item.status?.toLowerCase() === "pending"
                              ? "border-yellow-700 bg-yellow-100"
                              : "border-red-700 bg-red-100"
                          } ${item.status?.toLowerCase()}`}
                        >
                          {item.status}
                        </span>
                      </div>
                    </td>
                    <td className="capitalize">
                      <div className="text-center">
                        <MoreActionButton
                          onAction={handleChildAction}
                          details={item}
                        >
                          <button
                            onClick={() => openStatusChange(item)}
                            className="text-left"
                          >
                            Change Status
                          </button>
                        </MoreActionButton>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <TablePlaceholder lost="No Current Invoices" />
          )}
        </div>
      </div>
    </>
  );
};

export default AllInvoiceReport;
